'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
function getYoutubeEmbedLink(link) {
  const match = link.match(
    /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
  );
  const videoId = match && match[2].length === 11 ? match[2] : false;
  if (!videoId) return '';
  return `https://www.youtube.com/embed/${videoId}`;
}
exports.default = getYoutubeEmbedLink;
